import { createContext, useContext } from 'react';
import { createTracker } from 'usage-tracker';
// @ts-expect-error migrate upstream
import { getTrackingConfigOptions } from '../utils/trackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const getDefaultTracker = () => createTracker(getTrackingConfigOptions());
const ReportingActionsContext = /*#__PURE__*/createContext({
  tracker: getDefaultTracker()
});
export const useReportingActionsContext = () => {
  return useContext(ReportingActionsContext);
};
export const ReportingActionsContextProvider = props => {
  const {
    tracker = getDefaultTracker(),
    children
  } = props;
  return /*#__PURE__*/_jsx(ReportingActionsContext.Provider, {
    value: {
      tracker
    },
    children: children
  });
};